<template>
	<r-standard-modal-form 
		:style="{
			width: `500px`,
		}"
		@closeModal="$emit('closeModal')"
	>
		<div slot="title" class="modal-title">
			<div class="icon-wrapper">
				<p-icon icon="embed" />
			</div>
			Embed Visor Workbook
		</div>
		<div slot="body" class="embed-modal-body">
			<div class="education-line">
				You can embed this Visor workbook to share it in other apps like Notion, Confluence, and more.
			</div>
			<div class="embed-preview-label">
				Embed link
			</div>
			<p-textbox
				class="embed-text"
				:text="embedLink"
				type="standard"
				iconLeft="copy"
				:disabled="false"
				:readOnly="true"
				@onIconLeftClick="_event_copyEmbedLink"
			>
			</p-textbox>
			<div class="embed-preview-label">
				Embed code
			</div>
			<div 
				class="visor-embed-preview"
				@click="_event_copyEmbedHTML"
			>
				{{ iframeHTML }}
			</div>
			<div class="disclaimer-line">
				Only logged-in Visor users with access to this workbook will be able to see the contents.
				<span
					class="manage-share-button"
					@click="_event_openShareModal"
				>
					Manage sharing
				</span>
			</div>
			<div class="model-footer">
				<p-button 
					class="done-button" 
					type="standard"
					@onClick="closeForm"
				>
					Done
				</p-button>
			</div>
		</div>
	</r-standard-modal-form>
</template>

<script>

export default {
	name:'embed-modal',
	props:{
		sheetView:{
			required: true,
			type: Object,
		},
		dataStore:{
			required: true,
			type: Object,
		},
	},
	$pubsub:{},
	computed:{
		embedLink() {
			let sheetURL = new URL(window.location.href);
			sheetURL.searchParams.append("embed", true);
			sheetURL.searchParams.append("workspace", this.$root.systemState.auth.userDetails.user_org_guid)
			return sheetURL.href;
		},
		iframeHTML(){
			return `<iframe class="visor-embed" scr="${this.embedLink}" frameborder="0" onmousewheel="" width="100%" height="600" style="background:transparent; border: 1px solid #E0E2E8;"></iframe>`;
		},
	},
	methods:{
		closeForm(){
			this.$emit('closeModal');
		},
		_event_copyEmbedLink(){
			this.$pubsub.modules.clipboard.pub('rawCopy', this.embedLink);
			this.$pubsub.modules.toaster.pub("makeToast", {
				message: [{
					label: "Copied embed link to clipboard.",
					props: {
						class: "p-typography-regular-14"
					}
				}],
				type: "standard",
				location: "bottom-left",
				duration: 2000,
			});
		},
		_event_copyEmbedHTML(){
			this.$pubsub.modules.clipboard.pub('rawCopy', this.iframeHTML);
			this.$pubsub.modules.toaster.pub("makeToast", {
				message: [{
					label: "Copied embed code to clipboard.",
					props: {
						class: "p-typography-regular-14"
					}
				}],
				type: "standard",
				location: "bottom-left",
				duration: 2000,
			});
		},
		_event_openShareModal(){
			const vcSelf = this;
			vcSelf.$emit('closeModal');
			vcSelf.$pubsub.modules.sharing.pub('openModal', {
				dataStore: vcSelf.dataStore,
				onCloseCallback: function() {
					vcSelf.$pubsub.modules.embedModal.pub('openModal', {
						dataStore: vcSelf.dataStore,
						sheetView: vcSelf.sheetView
					});
				}
			});
		},
	}
}

</script>

<style scoped lang="scss">

.modal-title{
	display: grid;
	grid-template-columns: 32px auto;
	user-select: none;
	cursor: default;

	.icon-wrapper {
		display: inline-block;
		width: 20px;
		height: 20px;
		margin-top: 2px;
	}
}

.embed-modal-body{
	width: 100%;

	.education-line{
		margin-bottom: 6px;
		user-select: none;
		cursor: default;
	}

	.disclaimer-line{
		margin-top: 24px;
		user-select: none;
		cursor: default;

		.manage-share-button{
			@include clickable;
			color: $p-color-blue-300;
			user-select: none;
			cursor: pointer;
		}
	}
	.embed-preview-label{
		color: $p-color-grey-400;
		margin-top: 18px;
		margin-bottom: 6px;
		user-select: none;
		cursor: default;
	}
	.visor-embed-preview{
		font-family: monospace;
		font-weight: 600;
		padding: 6px 10px;
		border: 1px solid $p-color-grey-300;
		background-color: $p-color-white;
		color: $p-color-grey-600;
		cursor: default;
		user-select: all;

		&::selection {
		  background: $p-color-blue-100;
		}
		&::-moz-selection {
		  background: $p-color-blue-100;
		}
	}

	.model-footer{
		@include flex(row, flex-end, center);
		.done-button{
			margin-top: 12px;
		}
	}
}
</style>
